import React, { useState } from 'react';
import { SnackbarContext } from 'js/social/contexts/snackbar';
import SnackBar, { SnackbarProps } from 'js/social/shared/SnackBar';

export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [snackbarProps, setSnackbarProps] = useState<SnackbarProps | null>(
    null,
  );
  const [snackbarKey, setSnackbarKey] = useState(0);

  const showSnackbar = (
    message: SnackbarProps['message'],
    type?: SnackbarProps['type'],
    onClick?: SnackbarProps['onClick'],
    durationInMs?: SnackbarProps['durationInMs'],
    showIcon?: SnackbarProps['showIcon'],
  ) => {
    setSnackbarProps({ message, type, onClick, durationInMs, showIcon });
    setSnackbarKey((prevKey) => prevKey + 1);
  };

  return (
    <SnackbarContext.Provider value={{ showSnackbar }}>
      {snackbarProps && <SnackBar key={snackbarKey} {...snackbarProps} />}
      {children}
    </SnackbarContext.Provider>
  );
};
